import api, { apiAction, apiActionWithRoute } from '../../api'

import capitalize from '../../common/formatters/capitalize'

export const fetchItems = entityName => () => apiAction(api[`get${capitalize(entityName)}s`])()
export const addItem = entityName => item => apiAction(api[`add${capitalize(entityName)}`])(item)
export const deleteItem = entityName => entityId => apiActionWithRoute(api[`delete${capitalize(entityName)}`])(entityId)()
export const updateItem = entityName => (entityId, item) => apiActionWithRoute(api[`update${capitalize(entityName)}`])(entityId)(item)
